import { useNavigation } from "@react-navigation/native"
import { StackNavigationProp } from "@react-navigation/stack"
import { Button, useTheme } from "capsule"
import React, { useMemo } from "react"
import { useTranslation } from "react-i18next"
import { Image, Platform, Pressable, StyleSheet, View } from "react-native"
import FastImage from "react-native-fast-image"
import { KeyboardAwareScrollView } from "react-native-keyboard-aware-scroll-view"
import { Text } from "react-native-paper"
import { SafeAreaView } from "react-native-safe-area-context"

import { images } from "../../assets/images"
import LoginForm from "../../components/LoginForm"
import { LoginNS } from "../../features/i18n/constants"
import { IMainParamList } from "../MainScreen/MainNavigator"

const LoginScreen = () => {
  const {
    dimensions: { spacing },
    colors: {
      surface: { background },
      primary,
      accent,
      white,
    },
  } = useTheme()
  const navigation = useNavigation<StackNavigationProp<IMainParamList, "Account">>()

  const { t } = useTranslation(LoginNS)

  const { view, blueSection, link, headerSection, scrollContent } = useMemo(
    () => ({
      view: [styles.view, { backgroundColor: background }],
      headerSection: [styles.headerSection, { paddingHorizontal: spacing }],
      scrollContent: [styles.scrollContent, { paddingHorizontal: spacing }],
      blueSection: [styles.blueSection, { backgroundColor: accent, padding: spacing }],
      link: [styles.link, { color: primary }],
    }),
    [background, spacing, accent, primary],
  )
  const handleNavToOldMethod = () => {
    navigation.navigate("Cgu")
  }
  const handleRegister = () => {
    navigation.navigate("RegisterActivationCode")
  }
  const handleForgetPassword = () => {
    navigation.navigate("ForgotPassword")
  }

  return (
    <SafeAreaView style={view} testID="login-screen" edges={["top"]}>
      {/* Section fixe : Logo et Titre */}
      <View style={headerSection}>
        {Platform.OS === "web" ? (
          <Image source={images.logo} style={styles.image} testID="login-logo" />
        ) : (
          <FastImage
            source={images.logo as number}
            style={[styles.image as any]}
            resizeMode={FastImage.resizeMode.contain}
            testID="login-logo"
          />
        )}
        <Text style={styles.title} testID="login-title">
          {t("welcomeBack")}
        </Text>
      </View>

      {/* Section scrollable : Formulaire + Bloc bleu + Liens */}
      <KeyboardAwareScrollView
        style={styles.scrollView}
        contentContainerStyle={scrollContent}
        enableOnAndroid={true}
        extraScrollHeight={20}
        keyboardShouldPersistTaps="handled"
        keyboardOpeningTime={0}
      >
        <LoginForm />
        <View style={blueSection}>
          <Text style={styles.textBold}>{t("oldMethodCaption")}</Text>
          <Text>{t("oldMethodSecurity")}</Text>
          <View style={styles.section}>
            <Button
              onPress={handleNavToOldMethod}
              testID="login-old-method-link"
              contentStyle={{ backgroundColor: white.highEmphasis, width: "100%" }}
              labelStyle={{ color: primary }}
            >
              {t("oldMethodLink")}
            </Button>
          </View>
        </View>
        <View style={styles.section}>
          <Pressable onPress={handleRegister} testID="login-register-link">
            <Text style={link}>{t("accountCreation")}</Text>
          </Pressable>
          <Pressable onPress={handleForgetPassword} testID="login-forgot-password-link">
            <Text style={link}>{t("forgotPassword")}</Text>
          </Pressable>
        </View>
      </KeyboardAwareScrollView>
    </SafeAreaView>
  )
}

const styles = StyleSheet.create({
  view: {
    flex: 1,
  },
  headerSection: {
    paddingVertical: 20,
  },
  scrollView: {
    flex: 1,
  },
  scrollContent: {
    paddingBottom: 20,
    gap: 20,
  },
  title: {
    width: "100%",
    textAlign: "center",
    fontWeight: "bold",
    fontSize: 20,
  },
  textBold: {
    width: "100%",
    fontWeight: "bold",
    fontSize: 14,
  },
  section: {
    display: "flex",
    width: "100%",
    justifyContent: "center",
    gap: 4,
    alignItems: "center",
  },
  blueSection: {
    display: "flex",
    width: "100%",
    justifyContent: "center",
    gap: 12,
    alignItems: "flex-start",
    borderRadius: 8,
  },
  image: {
    zIndex: 100,
    width: "40%",
    height: 100,
    alignSelf: "center",
  },
  inLineView: {
    display: "flex",
    gap: 4,
    flexDirection: "row",
  },
  link: {
    fontWeight: "semibold",
  },
})

export default LoginScreen
